"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollingLayer = void 0;
var GameConstants_1 = require("./../../../GameConstants");
var GameVars_1 = require("../../../GameVars");
var ScrollingMenu_1 = require("./ScrollingMenu");
var BoardScene_1 = require("../BoardScene");
var BoardManager_1 = require("../BoardManager");
var GameManager_1 = require("../../../GameManager");
var ScrollingLayer = /** @class */ (function (_super) {
    __extends(ScrollingLayer, _super);
    function ScrollingLayer(scene, name) {
        var _this = _super.call(this, scene) || this;
        _this.name = name;
        var shape = new Phaser.GameObjects.Shape(_this.scene);
        shape.width = GameVars_1.GameVars.gameWidth;
        shape.height = GameVars_1.GameVars.gameHeight;
        shape.x = 0;
        shape.y = 0;
        var darkBackground = new Phaser.GameObjects.Graphics(_this.scene);
        darkBackground.fillStyle(0x321B38);
        darkBackground.fillRect(0, 0, GameVars_1.GameVars.gameWidth, GameVars_1.GameVars.gameHeight);
        darkBackground.alpha = .6;
        darkBackground.setInteractive(shape, function () {
            _this.onDownBackground(shape);
        });
        _this.add(darkBackground);
        _this.scrollingMenu = new ScrollingMenu_1.ScrollingMenu(_this.scene, _this.name, _this);
        _this.add(_this.scrollingMenu);
        var width = 540;
        var height = 1000 * GameVars_1.GameVars.scaleY;
        var x = GameVars_1.GameVars.gameWidth / 2 - width / 2;
        var y = GameVars_1.GameVars.gameHeight / 2 - height / 2 + 40 * GameVars_1.GameVars.scaleY;
        ScrollingLayer.pointerRect = {
            x: x,
            y: y,
            width: width,
            height: height
        };
        _this.visible = false;
        return _this;
    }
    ScrollingLayer.prototype.update = function () {
        this.scrollingMenu.update();
    };
    ScrollingLayer.prototype.appear = function () {
        this.alpha = 0;
        this.visible = true;
        ScrollingLayer.canBeClosed = false;
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350
        });
        this.scrollingMenu.updateCells();
        this.scene.time.delayedCall(300, function () {
            ScrollingLayer.canBeClosed = true;
        }, [], this);
    };
    ScrollingLayer.prototype.disappear = function () {
        this.visible = false;
    };
    ScrollingLayer.prototype.onDownBackground = function (shape) {
        if (BoardScene_1.BoardScene.currentInstance.input.activePointer.isDown && this.visible) {
            var x = BoardScene_1.BoardScene.currentInstance.input.activePointer.x;
            var y = BoardScene_1.BoardScene.currentInstance.input.activePointer.y;
            var insideRect = false;
            var rect = ScrollingLayer.pointerRect;
            if (x > rect.x && x < rect.x + rect.width && y > rect.y && y < rect.y + rect.height) {
                insideRect = true;
            }
            if (!insideRect && ScrollingLayer.canBeClosed) {
                BoardManager_1.BoardManager.hideScrollingLayer();
                GameManager_1.GameManager.updateLastPlayerAction();
                if (this.name === GameConstants_1.GameConstants.SHOP) {
                    this.scrollingMenu.hideNews();
                    BoardScene_1.BoardScene.currentInstance.unmarkShop();
                }
            }
        }
    };
    return ScrollingLayer;
}(Phaser.GameObjects.Container));
exports.ScrollingLayer = ScrollingLayer;
